<template>
  <div class="bar b ac">
    <div class="b ac">
      <img class="icon" src="@/assets/images/common/icon_gonggao.png" alt="" />
    </div>
    <div class="tit">温馨提示：</div>

    <div class="box">
      <p class="animate" v-if="this.noticeData">
        {{ this.noticeData.value }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: ['noticeData']
  // watch:{
  //   noticeData:(val)=>{
  //   }
  // }
};
</script>
<style lang="scss" scoped>
.bar {
  color: #ea0000;
  .icon {
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .tit {
    margin-left: 10px;
  }
  .box {
    width: 90%;
    overflow: hidden;
    height: 30px;
    .animate {
      width: 100%;
      height: 30px;
      line-height: 30px;
      color: #000;
      display: inline-block;
      white-space: nowrap;
      animation: 30s wordsLoop linear infinite;
      font-size: 12px;
      color: #ea0000;
    }
  }
  @keyframes wordsLoop {
    0% {
      transform: translateX(100%);
      -webkit-transform: translateX(100%);
    }
    100% {
      transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
    }
  }
  @-webkit-keyframes wordsLoop {
    0% {
      transform: translateX(100%);
      -webkit-transform: translateX(100%);
    }
    100% {
      transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
    }
  }
}
</style>
